<template>
  <div class="wrap">
    <div class="text" :class="{ noheight: isShow }">
      <div
        class="expand"
        :class="[isShow ? 'close' : 'open']"
        @click="isShow = !isShow"
      ></div>
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  name: "PartneBox",
  props: ["content"],
  data() {
    return {
      isShow: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
}

.text {
  font-size: 13px;
  color: #666666;
  line-height: 1.5;
  max-height: 3em;
  overflow: hidden;
  transition: all 0.3s;
  &::before {
    content: "";
    float: right;
    height: 100%;
    margin-bottom: -5vw;
  }
  &.noheight {
    max-height: none;
  }
}
.expand {
  float: right;
  clear: both;
  font-size: 12px;
  color: #4a79f1;
  &.open::before {
    content: "...";
    color: #666666;
    margin-right: 24px;
  }
  &.open::after {
    content: "展开";
  }
  &.close::after {
    content: "收起";
  }
}
</style>
